import { AppBar as MuiAppBar, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { RoomTypes } from '@weblite/ts-action/room'
import { RoomAvatar } from '$common/avatar/room-avatar'
import { BackButton } from '$common/buttons'
import { PageToolbar } from '$common/app-bar/common/page-toolbar'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const TitleTypography = styled(Typography)`
  flex-grow: 1;
`

interface Props {
  title: string
  roomType: RoomTypes | undefined
  roomId: string
  onBack: () => unknown
}

export function AppBar({ title, roomType, roomId, onBack }: Props) {
  return (
    <MuiAppBar>
      <PageToolbar sx={{ boxShadow: '0px 1px 4px #00000040' }}>
        <BackButton onClick={onBack} />
        <RoomAvatar
          size={AvatarSize.XS}
          roomId={roomId}
          roomType={roomType}
          sx={{ margin: '0 2px 0 10px' }}
          title={title}
        />

        <TitleTypography color="neutral900" variant="subtitle1">
          {title}
        </TitleTypography>
      </PageToolbar>
    </MuiAppBar>
  )
}
